import type { GlobeRoute } from "./types";

export const globeRoutes: GlobeRoute[] = [
  {
    order: 1,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 51.5072,
    endLng: -0.1276,
    arcAlt: 0.25,
    color: "#06b6d4",
  },
  {
    order: 2,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 40.7128,
    endLng: -74.006,
    arcAlt: 0.35,
    color: "#3b82f6",
  },
  {
    order: 3,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 43.6532,
    endLng: -79.3832,
    arcAlt: 0.3,
    color: "#6366f1",
  },
  {
    order: 4,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 52.52,
    endLng: 13.405,
    arcAlt: 0.25,
    color: "#06b6d4",
  },
  {
    order: 5,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 25.2048,
    endLng: 55.2708,
    arcAlt: 0.2,
    color: "#3b82f6",
  },
  {
    order: 6,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: -1.2921,
    endLng: 36.8219,
    arcAlt: 0.18,
    color: "#6366f1",
  },
  {
    order: 7,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: -33.9249,
    endLng: 18.4241,
    arcAlt: 0.26,
    color: "#06b6d4",
  },
  {
    order: 8,
    startLat: 6.5244,
    startLng: 3.3792,
    endLat: 28.6139,
    endLng: 77.209,
    arcAlt: 0.32,
    color: "#3b82f6",
  },
];

